import React, { useEffect, useState } from "react";
import "./HeroSlider.css";

const slides = [
    {
        image: "/images/slider/poster-1.jpg",
    },
];

const HeroSlider = () => {
    const [current, setCurrent] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrent((prev) => (prev + 1) % slides.length);
        }, 4000);
        return () => clearInterval(interval);
    }, []);

    return (
        <div className="hero-slider">
            {slides.map((slide, index) => (
                <div
                    key={index}
                    className={`slide ${index === current ? "active" : ""}`}
                >
                    <img src={slide.image} alt="slider" />

                </div>
            ))}
        </div>
    );
};

export default HeroSlider;